import {closeCurrentDialog, showNotification} from 'platform/components';

import {useHttpCalls} from '../../../api/useHttpCalls';
import type {SharePresetToUseRequestBody} from '../../../types/Api';

export const useSharePresetToUser = (presetId: string, gridCode: string) => {
  const {sharePresetToUser} = useHttpCalls({
    gridCode,
  });

  const onSubmit = (values: SharePresetToUseRequestBody) =>
    sharePresetToUser(presetId, values)
      .then(() => {
        showNotification.success();
        closeCurrentDialog();
      })
      .catch(() => showNotification.error());

  return {
    onSubmit,
  };
};
